import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
let LibModule = /*#__PURE__*/(() => {
  class LibModule {
    static {
      this.ɵfac = function LibModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LibModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: LibModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return LibModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function isFactory(param) {
  return typeof param === 'function';
}
function getProvideKey(param) {
  return isFactory(param) ? 'useFactory' : 'useValue';
}
function getProvideKeyByType(type) {
  return type === 'factory' ? 'useFactory' : 'useValue';
}

/**
 * Generated bundle index. Do not edit.
 */

export { LibModule, getProvideKey, getProvideKeyByType, isFactory };
